module.exports = __webpack_public_path__ + "static/media/startup-smart-second.58905418.jpg";